var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "join-form",
      attrs: {
        id: "join-channel-" + _vm.channel.id,
        method: "post",
        action: "",
        autocomplete: "off",
      },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.$emit("toggle-join-channel")
        },
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputChannel,
            expression: "inputChannel",
          },
          { name: "focus", rawName: "v-focus" },
        ],
        staticClass: "input",
        attrs: {
          type: "text",
          name: "channel",
          placeholder: "Channel",
          pattern: "[^\\s]+",
          maxlength: "200",
          title: "The channel name may not contain spaces",
          required: "",
        },
        domProps: { value: _vm.inputChannel },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputChannel = $event.target.value
          },
        },
      }),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.inputPassword,
            expression: "inputPassword",
          },
        ],
        staticClass: "input",
        attrs: {
          type: "password",
          name: "key",
          placeholder: "Password (optional)",
          pattern: "[^\\s]+",
          maxlength: "200",
          title: "The channel password may not contain spaces",
          autocomplete: "new-password",
        },
        domProps: { value: _vm.inputPassword },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputPassword = $event.target.value
          },
        },
      }),
      _c(
        "button",
        { staticClass: "btn btn-small", attrs: { type: "submit" } },
        [_vm._v("Join")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }